module.exports = __webpack_public_path__ + "media/img/user_blank-6dbd74d0c215cca10e7be82136866e19.png";